//泰语
export default {
	userDrawer:{ //抽屉导航
		data:[
			{name:'หน้าแรก'},
			{name:'ค้นหา'},
			{name:'การจำแนกประเภท'},
			{name:'ตะกร้าสินค้า'},
			{name:'เก็บรวบรวม'},
			{name:'ของฉัน'},
			{name:'ภาษา'},
		],
		language:[
			{name:'ภาษาจีน'},
			// {name:'ภาษาอังกฤษ'},
			// {name:'ภาษาฝรั่งเศส'},
			// {name:'ภาษาไทย'},
			{name: 'ພາສາສະເປນ'}
		]
	},
	page:{
		index:{ //首页
			mainNav:[
				{name:'การจำแนกประเภท'},
				{name:'เก็บรวบรวม'},
				{name:'ใบสั่งสินค้า'},
				{name:'ที่อย'},
			],
			coupons:'คูปอง',
			titProduct:'สินค้าชั้นนำ',
			titNow:'สินค้าขายด',
			titCate:'หมวดหมู่โดดเด่น',
			titBtn:'ดูทั้งหมด',
			titAlso:'อาจจะชอบ',
			couponDesc:'ยอดเงินสั่งซื้อเต็ม',
			received:'ได้รับแล้ว',
			orMore:'มากกว่า',
			viewDetails:'ดูรายละเอียด',
			recommended: 'รายการพิเศษ',
			promotions: 'สินค้าส่งเสริม',
			onView:'ดูรายการ',
			collectSite: 'บุ๊กมาร์กเว็บไซต์ของเรา',
			applyFor: 'สมัครสำหรับการตั้งถิ่นฐาน',
			mobileMall: 'ห้างมือถือ',
			shopStreet: 'ถนนช้อปปิ้ง',
			customerService: 'บริการลูกค้า',
			top: 'สูง',
			topOne: 'ลีดเดอร์บอร์ด',
			footer1: 'วาไรตี้เสร็จสมบูรณ์',
			footer2: 'จัดส่งที่รวดเร็ว',
			footer3: 'สินค้าของแท้',
			footer4: 'ราคาถูกทุกวัน',   
			address: "ห้อง 1101-04, Block A, Qihang Times Square, Xixian Avenue, Weiyang District, Xi'an City, Shaanxi Province",
			icp: "ซีอาน Zhongbang Network Technology Co., Ltd. มณฑลส่านซี ICP No. 14011498-3",
		},
		goodsDetail:{ //商品详情
			search:'ค้นหาสินค้า',
			sales:'ยอดการขาย',
			oldPrice:'ราคาเดิม',
			inventory:'คลังสินค้า',
			coupons:'คูปอง',
			choose:'เลือกแล้ว',
			choose1:'ກະລຸນາໃສ່ອ',
			Reviews:'การประเมินผลจากผู้ใช้สินค้า',
			good:'ชื่นชม',
			details:'รายละเอียดสินค้า',
			recommend:'สินค้าแนะนำ',
			home:'หน้าแรก',
			like:'เก็บรวบรวม',
			cart:'ตะกร้าสินค้า',
			addCart:'หยิบใส่ตะกร้า',
			buyNow:'ซื้อเลย',
			soldOut:'สินค้าขายหมดแล้ว',
			sold: 'ขายไปแล้ว',
			type:'ประเภทสินค้าที่มีจำหน่าย',
			navList:[
				{name:'สินค้าโภคภัณฑ'},
				{name:'การประเมิน'},
				{name:'แนะนำ'},
				{name:'รายละเอียด'}
			],
			select:'สินค้าที่เลือกแล้ว',
			clear:'ลบทั้งหมด',
			settle:'ไปชำระเงิน',
			num:'จำนวน',
			confirm:'แน่นอน',
			cancel: 'ยกเลิก',
			assure:"คุ้มกันการบริการ"
		},
		goodsList:{
			navTitle:'รายการสินค้า',
			search:'ค้นหาตามชื่อผลิตภัณฑ์',
			default:'ค่าเริ่มต้น',
			price:'ราคา',
			sales:'ยอดการขาย',
			new:'สินค้าตัวใหม่',
			empty:'ยังไม่มีสินค้าชั่วคราว,ลองดูสินค้าตัวอื่นไหม',
			no: 'ไม่มี',
			more: 'โหลดเพิ่มเติม',
			nono: 'ฉันมีขีด จำกัด',
			nomer: 'ไม่มีร้าน'
		},
		user:{
			navTitle:'ของฉัน',
			like:'คอลเลกชันของฉัน',
			integral:'คะแนนสะสมของฉัน',
			coupons:'คูปอง',
			orderCenter:'ศูนย์สั่งซื้อ',
			myOrder:'ใบสั่งชื้อของฉัน',
			placeLogin:'กรุณาคลิกเพื่อเข้าสู่ระบบ',
			orderStatus:[
				{name:'รอดำเนินการชำระเงิน'},
				{name:'รอดำเนินการจัดส่งสินค้า'},
				{name:'รอรับใบเสร็จ'},
				{name:'รอรับการประเมิน'},
				{name:'บริการหลังการขาย/คืนเงิน'},
				{name:'เรียบร้อยแล้ว'},
				{name:'ได้รับของแล้ว'}
			],
			services:'บริการอื่นๆ',
			address:'การจัดการที่อยู่',
			contact:'ติดต่อฝ่ายบริการลูกค้า',
			applicationRecord: 'ร้านสะสมของสะสม',
			goodsCollection: 'ของสะสมสินค้า',
			record: 'บันทึก',
			mineNav: [
				{name: 'ใบสั่งชื้อของฉัน'},
				{name: 'รายการคืนเงิน'},
				{name: 'รายการรีวิว'}
			],
			qunTitle: 'ข้อมูลใบอนุญาตประกอบธุรกิจ',
			qunDesc: 'ตามข้อกำหนดของการบริหารรัฐสำหรับอุตสาหกรรมและการพาณิชย์ "มาตรการจัดการธุรกรรมออนไลน์" ข้อมูลใบอนุญาตธุรกิจร้านค้าออนไลน์ได้รับการเผยแพร่ดังนี้:',
			qunCode: 'กรุณาใส่รหัสยืนยันภาพ',
			submit: 'ส่ง',
		},
		goodsSearch:{
			navTitle:'ค้นหาสินค้า',
			place:'คลิกเพื่อค้นหาสินค้า',
			search:'ค้นหา',
			hotSearch:'สินค้าที่มีการค้นหามากที่สุด',
			recommend:'สินค้าที่ขายดีที่สุด',
			emptySearch:'ไม่มีเกณฑ์การค้นหา ลองคำอื่น',
			placeSearch:'กรุณาระบุสินค้าที่ท่านต้องการค้นหา',
			onSearch:'กำลังค้นหา',
			goods:'สินค้าโภคภัณฑ์',
			mer: 'ร้านค้า',
			merchantType: 'ประเภทร้าน',
			merchantClassify:'ການ​ຈັດ​ປະ​ເພດ​ຜູ້​ຄ້າ​',
			sure :'ແນ່ນອນ',
			reset: 'ຣີເຊັດ',
			open: 'ขยายทั้งหมด',
			up: 'ເອົາໄປ',
			sort: 'เรียงลำดับ',
			Default: 'ค่าเริ่มต้น',
			Seller: 'ฝ่ายขาย',
			Price: 'ราคา',
			searchMer: 'ขออภัย ไม่พบร้านค้าที่คุณค้นหา~',
			searchGoods: 'ขออภัย ไม่พบสิ่งใดที่เกี่ยวข้องกับการค้นหาของคุณ~',
		},
		goodsAddcart:{
			navTitle:'ตะกร้าสินค้า',
			labelNav:'รับประกันคุณภาพสินค้า 100% และบริการหลังการขาย100%',
			buyNum:'จำนวนการสั่งชื้อ',
			management:'การจัดการ',
			cancel:'ยกเลิก',
			attribute:'คุณลักษณะ',
			failureGoods:'สินค้าหมดอายุ',
			empty:'สินค้าหมดสต๊อก',
			failure:'ไม่ถูกต้อง',
			fallDesc:'รายการนี้หมดอายุแล้ว',
			selectAll:'เลือกทังหมด',
			buyNow:'สั่งทันที',
			like:'เก็บรวบรวม',
			delete:'ลบ',
			emptyCart:'ยังไม่มีสินค้าชั่วคราว,,ต้องการสั่งสินค้าตัวอื่นเพี่มไหม',
			again: 'โปรดเลือกข้อกำหนดของผลิตภัณฑ์อีกครั้ง',
			reselect :'ການເລືອກຕັ້ງຄືນໃໝ່',
			productInfo: 'ข้อมูลสินค้า',
			unitPrice: 'ราคาต่อหน่วย',
			quantity: 'จำนวน',
			total: 'รวม',
			operate: 'ดำเนินการ',
		},
		orderPayStatus:{
			success:'ชำระเงินสำเร็จ',
			fail:'ชำระเงินไม่สำเร็จ',
			orderId:'เลขที่ใบสั่งซื้อ',
			orderTime:'เวลาสั่ง',// order of time
			payType:'วิธีการชำระเงิน',
			payPrice:'ยอดเงินที่ชำระ', //Pay the amount
			failReason:'สาเหตุของความล้มเหลว', //The reason for failure
			viewOrder:'ตรวจสอบคำสั่งซื้อ',//To view the order
			backHome:'กลับไปที่บ้าน'
		},
		orderDetails:{
			navTitle:'รายละเอียดการสั่งซื้อ',
			item:'รายการสั่งสินค้า',// item(s)
			Customer:'ติดต่อฝ่ายบริการลูกค้า',
			orderId:'เลขที่ใบสั่งซื้อ',
			copy:'สำเนา',
			orderTime:'เวลาสั่ง',
			refundTime: 'เวลาคืนเงิน',
			payStatus:'สถานะการชำระเงิน',
			payTrue:'ชำระเงินแล้ว',
			payFalse:'ยังไม่ชำระเงิน',
			payType:'วิธีการชำระเงิน',
			message:'ข้อความของผู้ซื้อ',
			name:'ผู้รับ',
			phone:'เบอร์ติดต่อ',
			address:'ที่อยู่จัดส่ง',
			returnReason:'เหตุผลที่กลับมา',
			returnMsg:'คำแนะนำในการคืนเงิน',
			returnImg: 'ບັດເຕີມເງິນຄືນ',
			sendMethod:'วิธีการจัดส่ง',
			sendOne:'การจัดส่งสินค้า', //send
			sendTwo:'ส่งสินค้า', //The delivery
			CourierCompany:'บริษัทจัดส่งสินค้าด่วน',//Courier company
			CourierNo:'เลขที่บิล', //Courier number
			deliveryName:'ชื่อผู้ส่งสินค้า',
			deliveryPhone:'เบอร์โทรติดต่อ',
			Virtual:'การจัดส่งตามจริง',//Virtual delivery
			deliveryMsg:'จัดส่งเรียบร้อยแล้ว, กรุณาเช็คให้ดี',
			allPrice:'ราคารวม',
			freight:'ค่าขนส่ง',
			coupon:'การใช้คูปองส่วนลด', //Coupon deduction
			point:'การใช้คะแนนเพื่อเป็นส่วนลด', //Points deduction
			actualPayment:'จ่ายเต็มจำนวน',//actual payment
			cancelOrder:'ยกเลิกคำสั่งซื้อ',
			nowPay:'ชำระเงินทันที',
			refund:'คำร้องขอเงินคืน',
			logistics:'กวดสอบพัสดุสินค้า',
			confirm:'ยืนยันการรับสินค้า',
			delete:'ลบคำสั่งซื้อ',
			again:'ซื้อซ้ำ',
			confirmInfo: 'เพื่อเป็นการปกป้องสิทธิและผลประโยชน์ โปรดยืนยันการรับสินค้าหลังจากยืนยันว่าสินค้าถูกต้อง',
			confirmDel: 'ตกลงที่จะลบคำสั่งซื้อนี้',
			confirmCancel: 'ยืนยันยกเลิกคำสั่งซื้อ'
		},
		users:{
			userInfo:{
				navTitle:'ติดตั้ง',
				avatar:'รูปโปรไฟล์',
				name:'ชื่อเล่น',
				email:'อีเมล',
				password:'รหัส',
				save:'บันทึกการเปลี่ยนแปลง',
				logOut:'ออกจากระบบ',
				phone:'เบอร์โทรศัพท์',
				msg: 'ชื่อผู้ใช้ไม่สามารถว่างเปล่า',
				personalCenter: 'ศูนย์ส่วนบุคคล',
			},
			orderConfirm:{
				setAddress:'กำหนดที่อยู่การรับสินค้า',
				navTitle:'สั่งชื้อสินค้า',
				items:'รายการ',
				coupons:'คูปอง',
				integral:'การใช้คะแนนเพื่อเป็นส่วนลด',
				freight:'ค่าขนส่ง',
				note:'หมายเหตุ',
				payPal:'จ่าย',
				allPrice:'ราคารวม',
				remaining:'คะแนนที่เหลือ',
				newIntegral:'คะแนนปัจจุบัน',
				free:'จัดส่งฟรี',
				placeNote:'กรุณาเพิ่มหมายเหตุ (ภายใน 150 ตัวอักษร)',
				CouponDeduction:'การใช้คูปองส่วนลด',
				total:'ยอดรวม',
        payment: 'กรุณาสแกนรหัสเพื่อทำการชำระเงิน',
        paymentResults: 'ชำระเงินแล้ว',
        paymentResultsNo: 'ยังไม่ได้ชำระเงิน',
			},
			orderList:{
				navTitle:'ใบสั่งชื้อของฉัน',
				orderNum:'ใบเสร็จสินค้า', //Cumulative order
				total:'รวมยอดทังหมด',//Total consumption
				orderStatus:[
					{name:'ที่รอดำเนินการชำระเงิน'},
					{name:'ที่รอดำเนินการจัดส่งสินค้า'},
					{name:'รอรับใบเสร็จ'},
					{name:'รอรับการประเมิน'},
					{name:'บริการหลังการขาย/คืนเงิน'},
				],
				item:'รายการ',// item(s)
				totalPay:'ยอดรวม',//total payment
				cancelOrder:'ยกเลิกคำสั่งซื้อ',
				viewDetails:'ดูรายละเอียด',
				evaluation:'การประเมิน',//evaluation
				evaluated:'ປະເມີນ',//evaluation
				delete:'ลบคำสั่งซื้อ',
				empty:'ยังไม่มีข้อมูลการสั่งซื้อ',
				pay:'ชำระเงินทันที',
				complete:'เสร็จ',
				orderInfo: 'ข้อมูลคำสั่งซื้อ',
			},
			userCoupon:{
				navTitle:'คูปองของฉัน',
				available:'ยังไม่ได้ใช้',
				expired:'ใช้แล้ว/หมดอายุการใช้งาน',
				min:'ลดเต็มที่',
				can:'ใช้ได้',
				used:'หมดอายุ',
				general:'สินค้าทั่วไป',
				goods:'สินค้า',
				cate:'หมวดหมู่',
				receive:'รับทันที',
				received:'ได้รับแล้ว',
				receivedInfo:'หลังจากได้รับ',
				receivedInfo1:'ມີໃຫ້ພາຍໃນມື້',
				navList:[
					{name:'พ่อค้า'},
					{name:'สินค้าโภคภัณฑ์'},
					{name:'หมวดหมู่'},
				],
				empty:'ยังไม่มีคูปองส่วนลด',
				valid:'ระยะเวลาที่ใช้ได้',
				day:'วัน',
        minus: 'minus',
        getUsers: 'ใช้'
			},
			userGoodsCollection:{
				navTitle:'เก็บรวบรวมของฉัน',
				item:'รายการสั่งสินค้า',
				management:'การจัดการ',
				cancel:'ยกเลิก',
				empty:'ยังไม่มียอดสั่งชื้อ,รีบๆติดตาม'
			},
			userAddressList:{
				navTitle:'การจัดการที่อยู่',
				default:'ตั้งเป็นค่าเริ่มต้น',
				add:'เพิ่มที่อยู่ใหม่',
				emptyAddress:'ยังไม่มีข้อมูลที่อยู่',
        edit:'ทบทวน',
        del:'ลบทิ้ง',
        sureDel: 'คุณแน่ใจว่าต้องการลบที่อยู่นี้'
			},
			userAddress:{
				navTitle:'การจัดการที่อยู่',
				name:'ชื่อ',
				Email:'อีเมล',
				country:'ประเทศ / ภูมิภาค',
				address:'รายละเอียดที่อยู่',
				postCode:'รหัสไปรษณีย์',
				phone:'เบอร์โทรศัพท์',
				default:'ตั้งเป็นค่าเริ่มต้น',
				save:'บันทึก',
				place:'กรุณาป้อนข้อมูน'
			},
			userReturnList:{
				navTitle:'คำร้องขอคืนสินค้า',
				orderId:'เลขที่ใบสั่งซื้อ',
				item:'รายการ',
				total:'ยอดรวม ',
				refunding:'การคืนเงิน',
				refunded:'คืนเงินแล้ว',
				examine: 'ร้านค้าอยู่ระหว่างตรวจทาน',
				examineInfo: 'คุณเริ่มต้นการสมัครขอคืนเงินได้สำเร็จ โปรดรออย่างอดทนเพื่อให้ผู้ค้าดำเนินการ โปรดเจรจากับผู้ขายก่อนที่จะคืนเงิน ซึ่งจะช่วยให้จัดการปัญหาหลังการขายได้ดียิ่งขึ้น',
			    examine1: 'ผู้ขายคืนเงินแล้ว',
				refuse: 'ไม่ยอมคืนเงิน',
				refuseReason: 'เหตุผลที่ปฏิเสธ：',
				refuseReason2: 'การรับเงินคืนสำเร็จแล้ว หากผู้ขายส่งสินค้าไปแล้ว กรุณาส่งคืนให้เร็วที่สุด ขอบคุณที่อุดหนุน',
			},
			goodsCommentList:{
				navTitle:'รีวิวสินค้า',
				score:'คะแนน',
				good:'เรตติ้งที่ดี',
				all:'ทั้งหมด',
				goodScore:'ดี',
				general:'ปานกลาง',
				bad:'ไม่ดี',
				attribute:'ขนาดจำเพาะ',
				seller:'พนักงานขาย'
			},
			goodsCommentCon:{
				navTitle:'รีวิวสินค้า',
				score:[
					{name:'คุณภาพของผลิตภัณฑ์'},
					{name:'ทัศนคติการบริการ'}
				],
				place:'สินค้าตรงตามความคาดหวังของคุณหรือไม่?พูดในสิ่งที่คุณคิด,แชร์ประสบการณ์ให้คนอยากซื้อ' ,
				upload:'อัพโหลดรูปภาพ',
				submit:'ให้คะแนนเลย',
				tips: 'ขอบคุณสำหรับความคิดเห็นของคุณ',
				tipsWrite: 'กรุณากรอกความคิดเห็นของคุณเกี่ยวกับผลิตภัณฑ์！',
        SU: 'การประเมินความสำเร็จ',
        tipsSU:'เราจะยังคงให้คุณด้วยสินค้าที่มีคุณภาพสูงและบริการ'
			},
			goodsReturn:{
				navTitle:'คำร้องขอเงินคืน', //Application for return
				number:'ปริมาณการส่งสินค้าคืน',
				price:'จำนวนเงินที่ส่งคืน',
				reason:'เหตุผลในการคืนสินค้า',
				info:'คู่มือการใช้งาน',
				voucher:'อัปโหลดใบรับรอง',
				place:'กรุณาเพิ่มหมายเหตุ (ภายใน 100 ตัวอักษร)',
				submit:'คำร้องขอเงินคืน' ,//Request a refund
				upload:'อัปโหลดใบรับรอง',
        detal:'รายละเอียดการคืนเงิน',
        information: 'ข้อมูลการคืนเงิน',
        refundList: 'รายการคืนเงิน'
			},
			login:{
				placeEmail:'กรุณากรอกอีเมล์',
				placePasd:'กรุณากรอกรหัส',
				sign:'ล็อกอิน',//SIGN IN
				create:'สร้างบัญชี', //Create account
				forget:'ลืมรหัส',
				quick:'ล็อกอินด่วน',
				pasdLogin:'ล็อกอินด้วยรหัส',
				with:'บุคคลทีสามที่ล็อกอิน',
				Pasdagain:'กรุณายืนยันรหัสผ่านของคุณ',
				submit:'ส่ง',
				next:'ขั้นตอนต่อไป',
				reset:'ตั้งรหัสผ่านใหม่',
				resetDesc:"กรุณากรอกอีเมลเพื่อรับการตรวจสอบ ",
				emailVer:"การยืนยันอีเมล",
				verDesc:'กรุณายืนยันอีเมลของคุณ เพื่อความปลอดภัยของบัญชี',
				tourists:'การซื้อโดยไม่ระบุชื่อ',
				continue:'ดำเนินการต่อ',
				phoneVer:'การยืนยันผ่านหมายเลขโทรศัพท์มือถือ',
        remember: 'จำรหัสผ่านของคุณ?'
			},
			register:{
				tabNav:[
					{name:'อีเมล'},
					{name:'หมายเลขโทรศัพท์มือถือ'}
				],
				placeEmail:'กรุณากรอกอีเมล์',
				placeCode:'กรุณาใส่รหัสยืนยัน',
				placePhone:'กรุณากรอกหมายเลขโทรศัพท์มือถือของท่าน',
				submit:'ลงทะเบียน',
				have:'มีบัญชีแล้ว',
				sign:'เข้าระบบ'
			},
			logistics:{
				navTitle:'รายละเอียดพัสดุขนส่ง',
				expName:'บริษัทขนส่ง',
				expNo:'เลขที่บิล',
			},
			userIntegral:{
				now:'คะแนนปัจจุบัน',
				totalInt:'คะแนนสะสม',
				totalPay:'ยอดสั่งชื้อสะสม',
				freeze:'คูปองถูกระงับการนำใช้',
				tabNav:[
					{name:"รายละเอียดคะแนน"},
					{name:"เพิ่มคะแนน"},
				],
				shopAdd:'รับคะแนนสะสมจากการซื้อสินค้า',
				make:'รับคะแนน',
				empty:'คะแนนที่ยังไม่ได้บันทึก'
			},
			replyList: {
				navTitle: 'Liste de révision'
			},
			wallet: {
				navTitle: 'รายการเงิน',
				all: 'ทั้งหมด',
				income: 'รายได้',
				spending: 'รายจ่าย',
				tableColumn: {
					type: 'ประเภท',
					amount: 'จำนวนเงิน',
					time: 'เวลา'
				}
			},
			invoiceList: {
				navTitle: 'รายการใบกำกับภาษี',
				openedCount: 'ใบกำกับภาษีที่ได้รับ',
				applyingCount: 'ใบกำกับภาษีที่กำลังดำเนินการ',
				orderNum: 'เลขที่ใบกำกับภาษี',
				tableColumn: {
					info: 'ใบกำกับภาษี',
					amount: 'จำนวนเงิน',
					title: 'ใบกำกับภาษี',
					type: 'ประเภท',
					date: 'วันที่',
					status: 'สถานะ',
					actions: 'ใบกำกับภาษี'
				},
				actionBtn: {
					viewInvoice: 'ดูใบกำกับภาษี',
					orderDetails: 'รายละเอียดใบกำกับภาษี'
				}
			}
		},
		store: {
			search: 'ค้นหาร้านค้า',
			followed: 'ติดตาม',
			follow: 'ຈຸດ​ສຸມ',
			storeRating: 'คะแนนร้านค้า',
			storeQualification: 'ຄຸນສົມບັດຂອງຮ້ານ',
			storeIntroduction: 'แนะนำร้าน',
			storeAddress: 'ที่อยู่ร้าน',
			storePhone: 'เบอร์โทรติดต่อ',
			storeService: 'ติดต่อฝ่ายบริการลูกค้า',
			storeTime: 'วลาเปิด-ปิดร้าน',
			storeName: 'ชื่อธุรกิจ',
			userName: 'ชื่อผู้ใช้',
			phone: 'เบอร์โทรติดต่อ',
			emil:'ที่อยู่อีเมล',
			code: 'รหัสยืนยัน',
			getCode: 'รับรหัสยืนยัน',
			class:'การจำแนกประเภทผู้ค้า',
			type:'ประเภทร้าน',
			place1:'โปรดอัปโหลดรูปถ่ายใบอนุญาตธุรกิจของคุณและคุณสมบัติที่เกี่ยวข้องกับอุตสาหกรรม',
			place2:'สามารถอัปโหลดรูปภาพได้สูงสุด 10 ภาพ และรูปแบบรองรับ JPG, PNG, JPEG',
			agree:'อ่านแล้วเห็นด้วย',
			agreement:'ข้อตกลงการเข้าพัก',
			submit:'ส่งใบสมัคร',
			agreement2:'ข้อตกลงระงับข้อพิพาทสำหรับผู้ค้า',
			Tips1:'ยินดีด้วย ข้อมูลของคุณถูกส่งเรียบร้อยแล้ว！',
			Tips2:'คาดว่าการตรวจสอบจะเสร็จสิ้นภายใน 15 วันทำการ และฝ่ายบริการลูกค้าของแพลตฟอร์มจะติดต่อคุณทันเวลา!',
			Tips3:'กลับไปที่บ้าน',
			title1:'พ่อค้าตกลง',
			title2:'มาร่วมกับเรา',
			street: 'ถนนร้านค้า',
			keyword: 'คีย์เวิร์ด',
			merInfo: 'รายละเอียดร้าน',
			index: 'หน้าแรก',
			classify: 'การจำแนกประเภท',
			collar: 'รับคูปอง',
			call: 'ติดต่อฝ่ายบริการลูกค้า',
			people: 'คนติดตาม',
			delFollow: 'ยกเลิกการสมัคร',
			selfSupport: 'อาชีพอิสระ',
      homeNav: [
        {name: 'หน้าแรก'},
        {name: 'การจำแนกประเภท'},
        {name: 'รับคูปอง'}
      ]
		}
	},
	message:{
		login:{
			loginLoading:'กำลังเข้าสู่ระบบ',
			getting:'กำลังได้รับ',
			emailEmpty:'กรุณากรอกอีเมล์',
			correctEmail:'กรุณากรอกอีเมล์ให้ถูกต้อง',
			emptyPassword:'กรุณากรอกรหัสผ่าน',
			againPassword:'กรุณายืนยันรหัสผ่านของคุณ',
			diffPassword:'รหัสผ่านทั้งสองข้างไม่เหมือนกัน',
			emptyPhone:'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
			emptyCaptche:'โปรดป้อนรหัสยืนยัน',
			correctCaptche:'โปรดป้อนรหัสยืนยันที่ถูกต้อง',
			loginSuccess:'เข้าสู่ระบบสำเร็จ',
			resetSuccess:'การตั้งค่ารหัสผ่านใหม่สำเร็จ',
			name:'กรุณากรอกชื่อผู้รับสินค้า',
			detail:'กรุณากรอกรายละเอียดที่อยู่',
			postCode:'กรุณากรอกรหัสไปรษณีย์',
			save:'กำลังบันทึกข้อมูล',
			updateSU:'แก้ไขเรียบร้อยแล้ว',
			saveSU:'บันทึกข้อมูลเสร็จ',
			prompt:'การแจ้งเตือน',
			confirmDel:'ยืนยันการลบหรืไม่?',
			logout:'คุณแน่ใจว่าคุณต้องการที่จะออกจากระบบ?',
			notExist:'ไม่มีที่อยู่เริ่มต้นที่คุณตั้งไว้',
			setSU:'ตั้งสำเร็จ',
			delSU:'ลบเรียบร้อยแล้ว',
			calSU:'ยกเลิกความสำเร็จ',
			send:'ส่ง',
			resend:'ส่งซ้ำ',
			remaining:'ยอดที่ยังเหลือ',
			operationSU: 'การดำเนินงานที่ประสบความสำเร็จ',
			loginSure: 'ใช้รหัสผ่านนี้เพื่อคงอยู่ในระบบหลังจากแก้ไข?',
			loginFacebook:'ผู้ใช้ปัจจุบันไม่ได้เข้าสู่ระบบ Facebook หรือเพจของคุณ',
      registerSU:'ลงทะเบียน',
      agreement: 'กรุณาตรวจสอบข้อตกลงความเป็นส่วนตัวของผู้ใช้',
      agree: 'ฉันได้อ่านและตกลง',
      agreementName: 'ข้อตกลงการใช้งาน'
		},
		pay:{
			orderFail:'การชำระเงินล้มเหลว',
			error:'พารามิเตอร์ที่หายไปไม่สามารถดูสถานะการชำระเงินของคำสั่งซื้อได้',
			errorOrder: 'ไม่สามารถดูหมายเลขคำสั่งซื้อที่หายไปได้'
		},
		orderConfirm:{
			payType:'กรุณาเลือกรูปแบบการชำระเงิน',
			emptyAddress:'กรุณาเลือกที่อยู่จัดส่ง',
			payLoading:'กำลังอยู่ระหว่างการชำระเงิน',
			productInfo: 'ข้อมูลสินค้า'
		},
		tips: {
			time: 'เวลายื่น',
			adopt:'สอบผ่าน',
			noadopt: 'การตรวจสอบล้มเหลว',
			reason: 'เหตุผล',
			stay: 'อยู่ระหว่างการพิจารณา',
			edit: 'แก้ไข',
			see: 'ตรวจสอบ',
			again: 'ส่งใหม่',
			shoppingSU: 'หยิบลงตะกร้าเรียบร้อย',
			loding: 'กำลังโหลด...',
			selectAddress: 'เลือกที่อยู่',
			selectOther: 'เลือกที่อยู่อื่น',
			surePay: 'คุณแน่ใจหรือไม่ว่าต้องการชำระเงินสำหรับการสั่งซื้อของคุณ',
			sureDel: 'ตกลงที่จะลบคำสั่งซื้อนี้',
			upPic:'ເຂົ້າຮ່ວມເຂົ້າຮ່ວມໄດ້ເພື່ອ5 ຂໍ້ມູນ',
			edidM: 'คลิกเพื่อเปลี่ยนรหัสผ่าน',
			sold: 'ขายแล้ว',
			changeGoods: 'ກະລຸນາໃສ່ອີກໂຕເລືອກ',
      picTips: 'อัพโหลดรูปแบบ JPG และ PNG',
      noEvaluation: 'ไม่มีความคิดเห็น~',
      more: 'แสดงเพิ่มเติม',
      hide: 'ซ่อนเพิ่มเติม',
      noDetal: 'ยังไม่มีรายละเอียดสินค้า',
      getSU: 'ได้รับเรียบร้อยแล้ว',
      browser: 'เนื่องจากเบราว์เซอร์ 360 มีฟังก์ชันจำกัด โปรดกด Ctrl+D เพื่อรวบรวมด้วยตนเอง!',
      nubrowser: 'เบราว์เซอร์ของคุณไม่รองรับ โปรดกด Ctrl+D เพื่อเพิ่มด้วยตนเอง!',
      error1: 'ขออภัย มีข้อผิดพลาดในหน้าที่คุณเยี่ยมชม',
      error2: 'โหลดไม่สำเร็จ',
      error3:'คำขอที่ไม่ดี',
      error4:'โปรดตรวจสอบไฟล์ปรับแต่งของคุณ',
      placeLogin: 'กรุณาเข้าสู่ระบบ'
		},
		settled: {
			emptyName:"กรุณากรอกชื่อบริษัท",
			emptyRealName:"กรุณาพิมพ์ชื่อของคุณ",
			emptyCaptcha:"กรุณากรอกรหัสยืนยัน",
			emptyCategory:"กรุณาเลือกหมวดหมู่ร้านค้า",
			emptyIsAgree:"โปรดทำเครื่องหมายและยอมรับข้อตกลงอาชีพ",
			emptyIsPicture:"กรุณาอัพโหลดภาพวุฒิการศึกษา",
			appleTips: 'ไม่มีประวัติการสมัคร ไปสมัครเรียนได้เลย'
		}
	}
}
